export const wo_area_url: string = "wo_area";
